<template>
    <div>
        <v-container fluid grid-list-xl class="home-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <v-layout row wrap class="">
                <v-flex xs12 class="padding-left-xxl padding-right-xxl">

                    <v-layout row justify-space-between class="details-buttons">
                        <v-flex xl4 sm5 xs12>
                            <div v-if="testRunDetails">
                                <span class="infoDetails" v-if="testRunDetails.productCode" v-html="testRunDetails.productCode"></span>
                                <span class="infoDetails" v-html="testRunDetails.applicationUrl"></span>
                                <span v-html="testRunDetails.username"></span>
                            </div>
                        </v-flex>

                        <v-flex xl3 sm6 xs12>
                            <div class="run-test-btn">
                                <v-btn xs2 @click="runTest" class="btn-test-pg">{{text("api.pro.tests.run")}}</v-btn>
                                <v-btn  @click="getTestTreeModified" class="footer-btn home modifiedTree btn-test-pg">
                                    <span>{{text("api.pro.tests.getTestTree")}}</span>
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-layout>

                    <div id="tree-container">

                            <test-tree></test-tree>

                    </div>

                </v-flex>
            </v-layout>

        </v-container>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';
    import HeaderBar from '../shared/HeaderBar';
    import TestTree from './TestTree';

    import axios from 'axios';


    export default {
        name: 'TestTreePage',
        components: {
            HeaderBar,
            TestTree
        },
        data : function () {
            return {
                view : TestTree
            }
        },

        computed: {
            ...mapGetters({
                testRunDetails: 'TestStore/getTestRunDetails'
            })
        },

        methods: {
            runTest() {
                    this.$router.push('/run-test');
                },
            getTestTreeModified() {
                console.log("download modified tree");
                axios({
                    url: process.env.API_BASE_URL + '/test/getTestTreeModified',
                    method: 'POST',
                    responseType: 'blob', // important
                }).then((response) => {
                    const testName = response.headers["file-name-value"];
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), testName); /* IE browser Solution*/
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', testName);
                        document.body.appendChild(link);
                        link.click();
                    }
                });
            }
        }


    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


    #cont{
        height: 100%;
    }
    .card-assesment {
        min-height: 600px;
    }

    .home-container.general-container {
        height:100%;
        overflow: hidden;
    }

    .row.wrap {
        height:100%;

        #tree-container{
            height: 100%;
        }
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .run-test-btn {
        float: right;
    }

    .infoDetails {
        margin-right: 10px;
    }

    .details-buttons {
        margin-top: 18px !important;
    }

    .run-test-btn .btn {
        height: 40px !important;
        font-weight: $font-weight-light;
    }

</style>




// WEBPACK FOOTER //
// src/professional/components/tests/TestTreePage.vue